.font-family {
  background-image: url("../images/font-family.svg");
}
